const NAME = 'PROGRAMS-INDEX';

// Handling of requests to /programs endpoint
export const REQUEST_PROGRAMS = `${NAME}/REQUEST_PROGRAMS`;
export const REQUEST_PROGRAMS_SUCCESS = `${NAME}/REQUEST_PROGRAMS_SUCCESS`;
export const REQUEST_PROGRAMS_FAIL = `${NAME}/REQUEST_PROGRAMS_FAIL`;

export const RESET_VIEW_STATE = `${NAME}/RESET_VIEW_STATE`;
export const RESET_STATE = `${NAME}/RESET_STATE`;
